/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Test_FailedInputs */

const en_settings_test_failed = /** @type {(inputs: Settings_Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test failed.`)
};

const he_settings_test_failed = /** @type {(inputs: Settings_Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הבדיקה נכשלה.`)
};

/**
* | output |
* | --- |
* | "Test failed." |
*
* @param {Settings_Test_FailedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_test_failed = /** @type {((inputs?: Settings_Test_FailedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Test_FailedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_test_failed(inputs)
	return he_settings_test_failed(inputs)
});